import React, { useState, useEffect } from "react"
import Layout from "../components/layout"
import Lateral from "../components/lateral"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import RichSnippet from "../components/richSnippet"
import ThemeContext from "../context/ThemeContext"
import json from "../translations.json"
import "../styles/entry.scss"

const nutritionTemplate = props => {
  const { path } = props
  const post = props.data.markdownRemark
  const nutrition = post.frontmatter
  const [storage, setStorage] = useState(undefined)

  useEffect(() => {
    setStorage(localStorage)
  }, [])

  return (
    <ThemeContext.Consumer>
      {({ lang }) => {
        if (storage) {
          storage.setItem("langPath", nutrition.langPath)
        }
        return (
          <Layout>
            <SEO
              title={nutrition.title}
              image={nutrition.SEOImage[0]}
              description={nutrition.description}
              creationDate={nutrition.datePublished}
              updateDate={nutrition.dateModified}
              ogType={"article"}
              path={nutrition.path}
            />
            <div className="entry">
              <div className="entry-content">
                <div>
                  <h1 className="h1-nutrition">{nutrition.title}</h1>
                  <div dangerouslySetInnerHTML={{ __html: post.html }}></div>
                  <RichSnippet content={nutrition} type="nutrition" />
                  {nutrition.video && (
                    <iframe
                      style={{
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginBottom: "20px",
                        marginTop: "20px",
                      }}
                      width="560"
                      height="315"
                      src={`https://www.youtube.com/embed/${nutrition.video}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  )}
                  <p>{lang ? json[lang].disclaimer : ""}</p>
                </div>
              </div>
              <Lateral showAbout={true} language={lang} path={path} />
            </div>
          </Layout>
        )
      }}
    </ThemeContext.Consumer>
  )
}

export const pageQuery = graphql`
  query NutritionPostByPath($path: String) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        langPath
        title
        video
        id
        keywords
        description
        datePublished
        dateModified
        headline
        SEOImage
        image {
          name
        }
      }
    }
  }
`

export default nutritionTemplate
